"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _jsxRuntime = require("react/jsx-runtime");
const CustomLinkField = props => {
  const {
    linkText,
    linkUrl
  } = props?.uiSchema["ui:widgetProps"];
  const {
    token: {
      colorPrimary
    }
  } = _antd.theme.useToken();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
    href: linkUrl,
    className: "float-right",
    style: {
      color: colorPrimary
    },
    children: linkText
  });
};
var _default = exports.default = CustomLinkField;